// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/pricing_info.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_money } from "../../core/money_pb";
import { file_proto_model_feature_hotel_cancellation_terms } from "./cancellation_terms_pb";

/**
 * Describes the file proto/model/feature/hotel/pricing_info.proto.
 */
export const file_proto_model_feature_hotel_pricing_info = /*@__PURE__*/
  fileDesc("Cixwcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL3ByaWNpbmdfaW5mby5wcm90bxIGY2FybWVuItsFCgtQcmljaW5nSW5mbxIhCgpiYXNlX3ByaWNlGAEgASgLMg0uY2FybWVuLk1vbmV5EjcKDWRhaWx5X3ByaWNpbmcYAiADKAsyIC5jYXJtZW4uUHJpY2luZ0luZm8uRGFpbHlQcmljaW5nEicKEHRvdGFsX3RheGVzX2ZlZXMYAyABKAsyDS5jYXJtZW4uTW9uZXkSJQoOb3JpZ2luYWxfcHJpY2UYBCABKAsyDS5jYXJtZW4uTW9uZXkSMgoIZGlzY291bnQYBSABKAsyIC5jYXJtZW4uUHJpY2luZ0luZm8uRGlzY291bnRJbmZvEjkKDnByaWNlX2luY2x1ZGVzGAYgASgLMiEuY2FybWVuLlByaWNpbmdJbmZvLlByaWNlSW5jbHVkZXMSNQoSY2FuY2VsbGF0aW9uX3Rlcm1zGAcgASgLMhkuY2FybWVuLkNhbmNlbGxhdGlvblRlcm1zGk0KDERhaWx5UHJpY2luZxIMCgRkYXRlGAEgASgJEhwKBXByaWNlGAIgASgLMg0uY2FybWVuLk1vbmV5EhEKCXJhdGVfdHlwZRgDIAEoCRp8CgxEaXNjb3VudEluZm8SGwoTZGlzY291bnRfcGVyY2VudGFnZRgBIAEoARImCg9kaXNjb3VudF9hbW91bnQYAiABKAsyDS5jYXJtZW4uTW9uZXkSEwoLZGVzY3JpcHRpb24YAyABKAkSEgoKcHJvbW9fY29kZRgEIAEoCRqsAQoNUHJpY2VJbmNsdWRlcxIaChJpbmNsdWRlc19icmVha2Zhc3QYASABKAgSFQoNaW5jbHVkZXNfd2lmaRgCIAEoCBIYChBpbmNsdWRlc19wYXJraW5nGAMgASgIEhYKDmluY2x1ZGVzX3RheGVzGAQgASgIEhwKFGluY2x1ZGVzX3Jlc29ydF9mZWVzGAUgASgIEhgKEG90aGVyX2luY2x1c2lvbnMYBiADKAlCNlo0Z2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWwvZmVhdHVyZS9ob3RlbGIGcHJvdG8z", [file_proto_model_core_money, file_proto_model_feature_hotel_cancellation_terms]);

/**
 * Describes the message carmen.PricingInfo.
 * Use `create(PricingInfoSchema)` to create a new message.
 */
export const PricingInfoSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_pricing_info, 0);

/**
 * Describes the message carmen.PricingInfo.DailyPricing.
 * Use `create(PricingInfo_DailyPricingSchema)` to create a new message.
 */
export const PricingInfo_DailyPricingSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_pricing_info, 0, 0);

/**
 * Describes the message carmen.PricingInfo.DiscountInfo.
 * Use `create(PricingInfo_DiscountInfoSchema)` to create a new message.
 */
export const PricingInfo_DiscountInfoSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_pricing_info, 0, 1);

/**
 * Describes the message carmen.PricingInfo.PriceIncludes.
 * Use `create(PricingInfo_PriceIncludesSchema)` to create a new message.
 */
export const PricingInfo_PriceIncludesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_pricing_info, 0, 2);

